// extracted by mini-css-extract-plugin
export default {"cls1":"H97YjwAApi6xy80z6Umg","cls2":"MPCVxKxqcBG7_wHYMTnA H97YjwAApi6xy80z6Umg","img":"XFnXb8m5kRZYteiq9Bkr"};